import * as actionTypes from '../types/modalError';

const initialState = {
  visible: false,
  message: '',
  techInfo: '',
  types: 'info',
  title: false,
  toLogin: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.MODAL_ERROR_OPEN:
      return {
        ...state,
        visible: true,
        message: payload.message,
        techInfo: payload.techInfo,
        types: payload.types,
        title: payload.title || false,
        toLogin: payload.toLogin || false
      };

    case actionTypes.MODAL_ERROR_CLOSE:
      return {
        ...state,
        visible: false,
        message: '',
        techInfo: '',
        types: 'info',
        title: false,
        toLogin: false
      };

    default:
      return state;
  }
};

export default reducer;
